import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { routes } from "./config/config";
import Home from "./pages/home/Home";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import PrivacyPolicy from "./pages/privacy-policy/PrivacyPolicy";
import TermsOfService from "./pages/terms-of-service/TermsOfService";
import UsersList from "./pages/admins/users/UsersList/UsersList";
import DeleteAccount from "./pages/delete-account/DeleteAccount";
import AdminDashboard from "./pages/admins/users/AdminDashboard/AdminDashboard";
import InfrastructureDashboard from "./pages/admins/users/infrastructure/InfrastructureDashboard";
import CategoriesList from "./pages/admins/categories/CategoriesList/CategoriesList";
import ConsultantsList from "./pages/admins/consultants/ConsultantsList/ConsultantsList";
import ConfigSettings from "./pages/admins/config/ConfigSettings/ConfigSettings";
import AdminGuard from "./components/AdminGuard";
import WebsiteAnimatedSplashScreenMobile from "./pages/auth/WebsiteAnimatedSplashScreenMobile";
import LandingScreen from "./pages/auth/LandingScreen";
import LoginWithEmailScreen from "./pages/auth/LoginWithEmailScreen";
import SignupScreen from "./pages/auth/SignupScreen";
import OTPScreen from "./pages/auth/OTPScreen";
import ForgotPasswordScreen from "./pages/auth/ForgotPasswordScreen";
import Reels from "./pages/home/reels/Reels";
import PlaceholderPage from "./pages/placeholder/PlaceholderPage";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DrawerNavigator from "./components/navigation/DrawerNavigator";
import { DrawerProvider } from "./contexts/DrawerContext";

function App() {
    return (
        <DrawerProvider>
            <BrowserRouter>
                <div className="App">
                <Routes>
                    {/* ==== Default Route - Splash Screen ==== */}
                    <Route path={routes.home} element={<WebsiteAnimatedSplashScreenMobile />} />
                    
                    {/* ==== Auth Routes ==== */}
                    <Route path={routes.splash} element={<WebsiteAnimatedSplashScreenMobile />} />
                    <Route path={routes.landing} element={<LandingScreen />} />
                    <Route path={routes.loginEmail} element={<LoginWithEmailScreen />} />
                    <Route path={routes.signup} element={<SignupScreen />} />
                    <Route path={routes.otp} element={<OTPScreen />} />
                    <Route path={routes.forgotPassword} element={<ForgotPasswordScreen />} />
                    
                    {/* ==== Main App Routes ==== */}
                    <Route path="/app/*" element={<DrawerNavigator />} />
                    <Route path={routes.reels} element={<Reels />} />

                    {/* ==== Users Routes ==== */}
                    <Route path={routes.deleteAccount} element={<DeleteAccount />} />
                    
                    {/* ==== Admins Routes ==== */}
                    <Route path={routes.adminDashboard} element={<AdminDashboard />} />
                    <Route path={routes.users} element={<UsersList />} />
                    <Route path={routes.infrastructureDashboard} element={<InfrastructureDashboard />} />
                    <Route path={routes.categories} element={<AdminGuard><CategoriesList /></AdminGuard>} />
                    <Route path={routes.consultants} element={<AdminGuard><ConsultantsList /></AdminGuard>} />
                    <Route path={routes.config} element={<AdminGuard><ConfigSettings /></AdminGuard>} />
                    
                    {/* ==== Legal Routes ==== */}
                    <Route path={routes.privacyPolicy} element={<PrivacyPolicy />} />
                    <Route path={routes.termsOfService} element={<TermsOfService />} />

                    {/* ==== Placeholder Routes ==== */}
                    <Route path={routes.reelDetails} element={<PlaceholderPage title="Reel Details" description="View individual reel details" />} />
                    <Route path={routes.user} element={<PlaceholderPage title="User Profile" description="View user profile" />} />
                    <Route path={routes.chats} element={<PlaceholderPage title="Chats" description="Your messages" />} />
                    <Route path={routes.profile} element={<PlaceholderPage title="Profile" description="Your profile" />} />
                    <Route path={routes.partyEventDetails} element={<PlaceholderPage title="Party Event" description="View event details" />} />
                    <Route path={routes.matchDetails} element={<PlaceholderPage title="Match Details" description="View match details" />} />
                    <Route path={routes.apartmentDetails} element={<PlaceholderPage title="Apartment Details" description="View apartment details" />} />
                    <Route path={routes.universitiesServices} element={<PlaceholderPage title="Universities" description="University services" />} />
                    <Route path={routes.eventDetails} element={<PlaceholderPage title="Event Details" description="View event details" />} />
                    <Route path={routes.restaurantDetails} element={<PlaceholderPage title="Restaurant" description="View restaurant details" />} />

                    {/* ==== 404 Route ==== */}
                    <Route path="*" element={<WebsiteAnimatedSplashScreenMobile />} />
                </Routes>
                <ToastContainer />
            </div>
        </BrowserRouter>
        </DrawerProvider>
    );
}

export default App;
